<template>
  <div style="height: calc(100vh - 100px);" class="disable-select">
    <v-toolbar dense dark class="file-nav-toolbar">
      <v-flex xs3></v-flex>
      <v-divider vertical></v-divider>
      <v-breadcrumbs :items="BreadcrumbData">
        <v-icon slot="divider">chevron_right</v-icon>
        <template slot="item" slot-scope="props">
          <a
            @click="goToCrumb(props.item)"
            v-if="BreadcrumbData.indexOf(props.item) != BreadcrumbData.length - 1"
          >{{ props.item.text }}</a>
          <div v-else>{{ props.item.text }}</div>
        </template>
      </v-breadcrumbs>
      <!-- <v-toolbar-side-icon></v-toolbar-side-icon>
      <v-toolbar-title>Title</v-toolbar-title>-->
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn flat icon @click="explorerViewType = 'grid'">
          <v-icon>mdi-grid</v-icon>
        </v-btn>
        <v-btn flat icon @click="explorerViewType = 'list'">
          <v-icon>mdi-view-list</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-layout fill-height align-start pb-5>
      <v-flex
        xs3
        fill-height
        style="overflow: auto; border-right: 1px solid;"
        @contextmenu.stop="show($event, null)"
      >
        <v-subheader>Files & Folders</v-subheader>
        <v-divider></v-divider>
        <v-treeview
          :items="FileFoldersTree"
          :load-children="GetChildren"
          item-children="Children"
          :active="active"
          :open="open"
          transition
          item-key="ID"
          loading-icon="mdi-loading"
        >
          <template slot="label" slot-scope="{ item, active, open }">
            <v-layout
              row
              align-center
              @click="setSelected(item)"
              @dblclick="openNode(item)"
              @contextmenu.stop="show($event, item)"
            >
              <v-avatar>
                <v-icon :color="active ? 'primary' : ''" v-if="item.Type == 1">mdi-file</v-icon>
                <v-icon
                  :color="active ? 'primary' : ''"
                  v-else
                >{{ open ? 'folder_open' : 'folder' }}</v-icon>
              </v-avatar>
              <span v-if="item.bCreated">{{item.Name}}</span>
              <span v-else>
                <input
                  type="text"
                  v-model="item.Name"
                  ref="newFolder"
                  v-on:keyup.13="submitFolder(item)"
                  v-on:keyup.esc="removeNewFolder(item)"
                >
              </span>
            </v-layout>
          </template>
          <template slot="prepend" slot-scope="{ item }">
            <v-icon v-if="item.Children" v-text="'folder-network'"></v-icon>
          </template>
        </v-treeview>
        <v-divider></v-divider>
        <v-subheader>Shared Files & Folders</v-subheader>
        <v-divider></v-divider>
        <v-subheader>Starred Files & Folders</v-subheader>
        <v-divider></v-divider>
      </v-flex>
      <v-flex xs9 fill-height @contextmenu.stop="show($event, null, 'explorer')">
        <v-data-table
          :headers="TableHeaders"
          :items="ExplorerItems"
          hide-actions
          dark
          v-if="explorerViewType == 'list'"
        >
          <template v-slot:items="props">
            <td
              @click="setExplorerSelected(props.item)"
              @dblclick="setSelected(props.item)"
            >{{ props.item.Name }}</td>
          </template>
        </v-data-table>
        <v-container fluid grid-list-sm v-if="explorerViewType == 'grid'">
          <v-layout row wrap>
            <v-flex row text-xs-center v-if="ExplorerItems.length == 0">NO ITEMS IN FOLDER</v-flex>
            <v-flex
              v-else
              v-for="item in ExplorerItems"
              :key="item.ID"
              xs3
              @contextmenu.stop="show($event, item)"
            >
              <v-layout
                column
                wrap
                justify-center
                text-xs-center
                ma-1
                class="grid-item"
                :class="{'active': item == ExplorerSelectedItem}"
                elevation-5
                @click="setExplorerSelected(item)"
                @dblclick="setSelected(item)"
              >
                <v-icon v-if="item.Type == 0" large>mdi-folder</v-icon>
                <v-icon v-else large>mdi-file</v-icon>
                <span v-if="item.bCreated">{{item.Name}}</span>
                <span v-else>
                  <input
                    type="text"
                    v-model="item.Name"
                    ref="newFolder"
                    v-on:keyup.13="submitFolder(item)"
                    v-on:keyup.esc="removeNewFolder(item)"
                  >
                </span>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <v-menu
      v-model="showMenu"
      :position-x="x"
      :position-y="y"
      absolute
      offset-y
      content-class="context_menu"
    >
      <v-list>
        <v-list-tile @click="addFolder">
          <v-icon>create_new_folder</v-icon>
          <v-list-tile-title>New Folder</v-list-tile-title>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile @click="addFile">
          <v-icon>note_add</v-icon>
          <v-list-tile-title>Upload File</v-list-tile-title>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile @click="deleteFileFolder" v-if="contextItem != null">
          <v-icon>remove_circle</v-icon>
          <v-list-tile-title>Delete {{contextItemTypeString}}</v-list-tile-title>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile @click="shareFileFolder" v-if="contextItem != null">
          <v-icon>cloud_download</v-icon>
          <v-list-tile-title>Share {{contextItemTypeString}}</v-list-tile-title>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile @click="downloadFile" v-if="contextItem != null && contextItem.Type == 1">
          <v-icon>share</v-icon>
          <v-list-tile-title>Download File</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
    <input type="file" style="display:none;" ref="fileInput" @change="onFileChange" multiple>
  </div>
</template>

<script>
import axios from "axios";
import JWT from "jsonwebtoken";

export default {
  name: "FileManager",
  data() {
    return {
      TableHeaders: [
        {
          text: "Name",
          sortable: false
        }
      ],
      FileFoldersTree: [],
      AllFileFolders: [],
      ExplorerItems: [],
      BreadcrumbData: [
        {
          text: "Root",
          disabled: false,
          ID: -1
        }
      ],
      active: [],
      open: [],
      showMenu: false,
      x: 0,
      y: 0,
      contextItem: null,
      contextView: null,
      contextItemTypeString: null,
      explorerViewType: "grid",
      SelectedItem: null,
      ExplorerSelectedItem: null
    };
  },
  created() {
    this.GetFiles();
    this.ExplorerItems = this.FileFoldersTree;
  },
  watch: {
    active(activeVal) {
      let self = this;

      if (activeVal.length == 0) {
        self.ExplorerItems = this.FileFoldersTree;
        return;
      }

      var id = activeVal[0];

      self.FindFileFolderItem(id).then(response => {
        if (response.Type == 0) {
          var bOpen = self.open.includes(id);

          if (!bOpen) {
            self.open.push(id);
          }

          if (response.Children == null || response.Children.length == 0) {
            self.get("FileFolder?ParentID=" + response.ID).then(r => {
              self.ExplorerItems = [];

              r.data.forEach(el => {
                el.bCreated = true;
                self.ExplorerItems.push(el);
              });
            });
          } else {
            self.ExplorerItems = response.Children;
          }

          self.CheckBreadcrumb(response);
        }
      });
    }
  },
  methods: {
    GetFiles(addToExplorer) {
      let self = this;
      let userId = JWT.decode(sessionStorage["accessToken"]).USER_ID;

      this.get("FileFolder?SystemUserID=" + userId).then(response => {
        response.data.forEach(element => {
          element.bCreated = true;

          if (element.Type == 0) {
            element.Children = [];
          }

          self.FileFoldersTree.push(element);
          self.AllFileFolders.push(element);
        });
      });
    },
    async GetChildren(folderItem) {
      let self = this;
      return this.get("FileFolder?ParentID=" + folderItem.ID).then(r => {
        r.data.forEach(element => {
          element.bCreated = true;

          if (element.Type == 0) {
            element.Children = [];
          }

          folderItem.Children.push(element);
          self.AllFileFolders.push(element);
        });
      });
    },
    show(e, item, view) {
      e.preventDefault();
      let self = this;

      this.contextItem = item;
      this.contextView = view;

      if (item != null) {
        this.SelectedItem = item;

        if (item.Type == 0) {
          this.contextItemTypeString = "Folder";
        } else {
          this.contextItemTypeString = "File";
        }
      }

      this.showMenu = false;
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        self.showMenu = true;
      });
    },
    setSelected(item) {
      this.active = [item.ID];
      this.SelectedItem = item;
    },
    setExplorerSelected(item) {
      this.ExplorerSelectedItem = item;
    },
    addFolder() {
      let self = this;
      let folderItem = this.contextItem;

      var arrToPush;

      if (this.contextView == "explorer") {
        arrToPush = this.ExplorerItems;
      } else {
        arrToPush = this.FileFoldersTree;
      }

      if (folderItem == null) {
        arrToPush.push({
          Name: "New Folder",
          bCreated: false,
          ParentID: self.BreadcrumbData[self.BreadcrumbData.length - 1].ID,
          Children: []
        });
      } else {
        this.active = [folderItem.ID];

        if (this.contextView == "explorer") {
          arrToPush.push({
            Name: "New Folder",
            bCreated: false,
            ParentID: self.BreadcrumbData[self.BreadcrumbData.length - 1].ID,
            Children: []
          });
        } else {
          self.FindFileFolderItem(folderItem.ID).then(response => {
            response.Children.push({
              Name: "New Folder",
              bCreated: false,
              ParentID: folderItem.ID,
              Children: []
            });
          });
        }
      }

      setTimeout(() => {
        self.$refs.newFolder.focus();
      }, 250);
    },
    addFile() {
      this.$refs.fileInput.click();
    },
    onFileChange(e) {
      let self = this;

      let userId = JWT.decode(sessionStorage["accessToken"]).USER_ID;
      let files = e.target.files;
      //let file = files[0];

      for (let index = 0; index < files.length; index++) {
        const file = files[index];

        var request = {
          SystemUserID: userId,
          Name: file.name,
          Type: 1,
          ParentID: self.SelectedItem.ID,
          Shared: false,
          Starred: false
        };

        this.post("FileFolder", request).then(r => {
          self.uploadFile(file, r.data);
          self.FindFileFolderItem(r.data.ParentID).then(parentFolder => {
            var item = r.data;
            item.bCreated = true;

            parentFolder.Children.push(item);
            self.ExplorerItems.push(item);
          });
        });
      }
      //this.uploadFile(file);

      let amountOfFiles = files.length;
    },
    uploadFile(file, fileData) {
      let self = this;
      let userId = JWT.decode(sessionStorage["accessToken"]).USER_ID;

      var xhrObj = new XMLHttpRequest();

      let config = JSON.parse(sessionStorage.Config);
      let token = sessionStorage["accessToken"];

      var url =
        config.ServerAddress +
        `FileFolder?parentID=${fileData.ParentID}&userID=${
          fileData.SystemUserID
        }`;

      xhrObj.open("POST", url);

      xhrObj.upload.onprogress = function(pe) {
        // if (pe.lengthComputable) {
        //   self.$refs.progressDialog.setCurrentValue(
        //     (pe.loaded / pe.total) * 100
        //   );
        // }
      };

      xhrObj.upload.onloadstart = function(e) {};

      xhrObj.upload.onloadend = function(e) {
        //resolve(e);
      };

      xhrObj.upload.onerror = function(e) {
        //reject(e);
      };

      xhrObj.setRequestHeader("filename", file.name);
      xhrObj.setRequestHeader("Authorization", "bearer " + token);

      xhrObj.send(file);
    },
    deleteFileFolder() {
      let self = this;
      this.delete("FileFolder?id=" + this.contextItem.ID).then(response => {
        self.removeFolder(this.contextItem);
      });
    },
    shareFileFolder() {},
    downloadFile() {},
    submitFolder(folderItem) {
      let self = this;
      let userId = JWT.decode(sessionStorage["accessToken"]).USER_ID;

      var request = {
        SystemUserID: userId,
        Name: folderItem.Name,
        Type: 0,
        ParentID: folderItem.ParentID,
        Shared: false,
        Starred: false
      };

      this.post("FileFolder", request).then(r => {
        var newItem = r.data;
        newItem.bCreated = true;
        newItem.Children = [];

        self.FindFileFolderItem(r.data.ParentID).then(response => {
          response.Children.splice(
            response.Children.indexOf(folderItem),
            1,
            newItem
          );
        });
      });
    },
    removeFolder(item) {
      let self = this;

      if (item.ParentID == -1) {
        self.FileFoldersTree.splice(self.FileFoldersTree.indexOf(item), 1);
      } else {
        function Recursive(fileFolders, parentItem) {
          fileFolders.forEach(el => {
            if (el.ID == item.ID) {
              parentItem.Children.splice(parentItem.Children.indexOf(el), 1);
            } else {
              if (el.Type == 0) {
                Recursive(el.Children, el);
              }
            }
          });
        }

        Recursive(self.FileFoldersTree);
      }
    },
    removeNewFolder(item) {
      let self = this;

      function Recursive(fileFolders, parentItem) {
        fileFolders.forEach(el => {
          if (!el.bCreated) {
            if (el.ParentID == -1) {
              self.FileFoldersTree.splice(
                self.FileFoldersTree.indexOf(item),
                1
              );
            } else {
              parentItem.Children.splice(parentItem.Children.indexOf(item), 1);
            }
          } else {
            Recursive(el.Children, el);
          }
        });
      }

      Recursive(self.FileFoldersTree);
    },
    FindFileFolderItem(id) {
      let self = this;
      return new Promise(function(resolve, reject) {
        function Recursive(fileFolders) {
          fileFolders.forEach(el => {
            if (el.ID == id) {
              resolve(el);
            } else {
              if (el.Children != undefined && el.Children.length > 0) {
                Recursive(el.Children);
              }
            }
          });
        }

        Recursive(self.FileFoldersTree);
      });
    },
    openNode(item) {
      let self = this;
      let id = item.ID;
      var bOpen = self.open.includes(id);

      if (!bOpen) {
        self.open.push(id);
      }
    },
    goToCrumb(item) {
      if (item.ID == -1) {
        this.active = [];
        this.BreadcrumbData = [
          {
            text: "Root",
            disabled: false,
            ID: -1
          }
        ];
      } else {
        this.active = [item.ID];
      }
    },
    CheckBreadcrumb(activeRoute) {
      let self = this;
      let parentID = activeRoute.ParentID;
      let dataObj = self.BreadcrumbData;

      if (dataObj.length == 0) {
        dataObj.push({
          text: activeRoute.Name,
          disabled: true,
          parentID: activeRoute.ParentID,
          ID: activeRoute.ID
        });
        return;
      }

      var index = dataObj.length - 1;
      var lastObject = dataObj[index];

      if (lastObject.ID == activeRoute.ID) {
        return;
      }

      if (lastObject.ID == parentID) {
        dataObj.push({
          text: activeRoute.Name,
          disabled: false,
          ID: activeRoute.ID,
          ParentID: parentID
        });
      } else {
        var parent = this.FindParentByID(parentID, dataObj);
        if (parent != false) {
          var index = dataObj.indexOf(parent);
          dataObj.splice(index + 1, dataObj.length - 1);
          dataObj.push({
            text: activeRoute.Name,
            disabled: true,
            parentID: activeRoute.ParentID,
            ID: activeRoute.ID
          });
        } else {
          dataObj.splice(1, dataObj.length);
          self.CheckRecursive(activeRoute, dataObj, self.AllFileFolders);
        }
      }
    },
    CheckRecursive(item, dataObj, treeItems) {
      dataObj.splice(1, 0, {
        text: item.Name,
        disabled: false,
        parentID: item.ParentID,
        ID: item.ID
      });

      //dataObj[dataObj.length - 1].disabled = true;

      var parent = this.FindParentByID(item.ParentID, treeItems);

      if (parent != false) {
        this.CheckRecursive(parent, dataObj, treeItems);
      }
    },
    FindParentByID(parentID, dataObj) {
      var retVal = dataObj.filter(el => {
        return el.ID == parentID;
      });

      if (retVal.length > 0) {
        return retVal[0];
      } else {
        return false;
      }
    }
  }
};
</script>

<style>
.disable-select {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.file-nav-toolbar .v-toolbar__content {
  padding: 0;
}

.grid-item.active {
  border: 2px solid #ff9800;
}
</style>